<template>
			<v-list-item>
				<v-list-item-content>
					<v-list-item-title>
						{{allowedDisplayName(room.participant)}} 
					</v-list-item-title>
					<v-list-item-subtitle>
						{{ room.dateTime.toDate() | moment("dddd, MMMM Do YYYY, h:mm a") }}
						<p class="text-right" v-if="!room.composition">
							Generate new recording
						</p>
						<div v-else>
							<p class="text-right mb-0" v-if="room.composition"> 
								{{compositionStatus(room.composition.status)}}
							</p>
							<v-progress-linear class="mt-2" v-if="room.composition.percentageComplete" color="green" v-model="room.composition.percentageComplete"></v-progress-linear>
							<p class="text-right mt-0"><span class="overline">{{ room.composition.created.toDate() | moment("dddd, MMMM Do YYYY, h:mm a") }}</span></p>
						</div>
					</v-list-item-subtitle>
				</v-list-item-content>
				<v-list-item-icon>

					<v-dialog v-model="dialog" width="460px" v-if="!room.composition">
						<template v-slot:activator="{ on }">
							<v-btn color="green" icon dark v-on="on"><v-icon>mdi-plus-circle</v-icon></v-btn>
						</template>
						<v-card>					
							<v-card-title>Are you sure?</v-card-title>		
							<v-card-text>
								<p>Recordings are the video and audio tracks from each participant in one single media file.
								These can take approximately 2 hours to be rendered.</p> 
								
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn v-if="!room.composition" @click="generateRecording(room.appointment, room.roomSid)" color="red" dark>
									Generate New Recording
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
					<span v-if="room.composition">
						<v-btn v-if="room.composition.status == 'composition-available'" color="green" icon dark @click="getCompositionDownload(room.composition)"><v-icon>mdi-download</v-icon></v-btn>
						<v-tooltip bottom v-else>
							<template v-slot:activator="{ on }">
								<v-icon	v-on="on">mdi-help-circle</v-icon>
							</template>
							<span>Recordings can take approximately an hour to be rendered</span>
						</v-tooltip>
					</span>
				</v-list-item-icon>
			</v-list-item>
</template>


<script type="text/javascript">
	import Vuex from "vuex";
	import axios from 'axios';
	import {prettyPrint} from "@/assets/utilities.js"
	// import {localDateTimeString} from "../../assets/timezoneFunctions.js"
	import {visibleDisplayName} from "../../assets/permissionsFunctions.js"
	export default {
		name: "RecordingsListItem", 
		props: {
			room: {type: Object},
			project: {type: Object}
		},
		data: () => {
			return {
				dialog: false, 
				downloading: false 
			}
		},
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user, 
			}), 
		},
		methods: {
			allowedDisplayName(participant) {
				return visibleDisplayName( this.user, participant, this.project )
			},
			async getDownload(compositionSid, id) {
				return await axios.get(`https://x.m.works:1880/twilio/updateRecording/${compositionSid}/${id}`)
				// return await axios.get(`http://localhost:3000/token?identity=${identity}`);
			},
			getCompositionDownload(composition){
				// event.preventDefault();
				const self = this;
				self.getDownload( composition.compositionSid, composition.id).then( ( ) => {
					let a = document.createElement('a')
					a.href = composition.compositionLink
					document.body.appendChild(a)
					a.click()
					document.body.removeChild(a)
				// 	location.href = composition.compositionLink;
				// 	self.downloading = false;
				// 	console.log( "" )
				})
			},
			compositionStatus(status){
				if( status.substring(0,11) !== "composition"){
					status = "composition-" + status;
				}
				status = status.replace("composition", "recording" )
				return prettyPrint(status, "TITLE")
			},
			warning(roomSid){
				const self = this;
				var recording = self.videoCompositions.find( a => a.roomSid == roomSid );
				if( !recording ){
					return false;
				}
				else{
					return true;
				}
			},
			generateRecording(appointment, roomSid){
				var self = this;
				var user = self.user.uid;
				self.$store.dispatch( "addDoc", {
					collection: "videoCompositions", 
					data: {
						roomSid: roomSid, 
						user: user, 
						appointment: appointment,
						status: 'initiated'
					}
				}).then( () => {
					// self.dialog = false;
				})
			} 
		}
		// created(){
			
		// }

	}
// </script>"